import { MouseEvent, useState } from 'react';
import { useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { useInfiniteAvailableVouchers } from '../../../../../services/modules/business-policies/businessPolicies.queries';
import { useAppEnvironmentStore } from '../../../../../stores/AppEnvironment/appEnvironment.store';
import { selectIsInStoreEnvironment } from '../../../../../stores/AppEnvironment/appEnvironment.store.selectors';
import useOrderBookStore from '../../../../../stores/OrderBook/orderBook.store';
import { useAbility } from '../../../../users/AbilityContext';

const useVoucherMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const ability = useAbility();
  const { isVoucherEnabled } = useFeatureFlag();
  const isInStoreEnvironment = useAppEnvironmentStore(selectIsInStoreEnvironment);
  const orderId = useOrderBookStore((state) => state.selectedOrder?.id);

  const { query } = useInfiniteAvailableVouchers({ orderId }, { isEnabled: !!anchorEl });

  return {
    anchorEl,
    isVisible:
      isVoucherEnabled && !isInStoreEnvironment && ability.can('read', 'business-policies'),
    vouchers: query.pagesData ?? [],
    isLoading: query.isLoading,
    isLoadingMore: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: query.fetchNextPage,
    openMenu: (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget),
    closeMenu: () => setAnchorEl(null),
  };
};

export default useVoucherMenu;
